import { Skeleton, Box, Grid2 as Grid } from "@mui/material";

const SchemaFormSkeleton = () => {
  return (
    <Box className="min-w-full space-y-[1.875rem] flex-box">
      {/* Form Skeleton */}
      <Grid container columnSpacing={4}>
        {/* Left Panel */}
        <Grid
          container
          direction="column"
          size={{ xs: 6 }}
          className="space-y-[1.875rem]"
        >
          <Skeleton variant="rectangular" width="100%" height={56} />
          <Skeleton variant="rectangular" width="100%" height={56} />
          <Skeleton variant="rectangular" width="60%" height={40} />
          <Skeleton variant="rectangular" width="100%" height={56} />
          <Skeleton variant="rectangular" width="40%" height={56} />
          <Skeleton variant="rectangular" width="100%" height={56} />
        </Grid>

        {/* Right Panel */}
        <Grid size={{ xs: 6 }}>
          <Box className="h-full rounded-[10px] bg-gray-input p-[1.875rem] space-y-[1.25rem]">
            <Box className="flex justify-between items-center">
              <Skeleton variant="text" width="30%" height={30} />
              <Skeleton variant="rectangular" width={100} height={40} />
            </Box>
            <Skeleton variant="rectangular" width="100%" height={80} />
            <Skeleton variant="rectangular" width="100%" height={200} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SchemaFormSkeleton;
